// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 분배금 등록 화면 */

/* ── 툴바 ── */
.div-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
}

.div-toolbar-label {
  font-size: 12px;
  font-weight: 600;
  color: #444;
  flex-shrink: 0;
}

.div-acct-select,
.div-year-select,
.div-toolbar select {
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
}

.div-year-select {
  width: 72px;
}

.div-date-input {
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
}

.div-summary-text {
  font-size: 12px;
  color: #333;
  margin-left: 8px;
  white-space: nowrap;
}

.div-summary-text strong {
  color: #1a56db;
}

/* ── 정렬 가능한 헤더 ── */
.div-sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.div-sortable:hover {
  background-color: #e8ebf8;
}

/* ── 고정 컬럼 (left 오프셋) ── */
/* freeze-c2, freeze-c3 left는 인라인 style로 동적 설정 */
.div-grid .freeze-c1 { left: 0;     border-right: 1px solid #dde2ef; }
.div-grid .freeze-c2 {              border-right: 1px solid #dde2ef; }
.div-grid .freeze-c3 {              border-right: 2px solid #cdd3e8; }

/* 고정 컬럼 배경 (스크롤 시 투명 방지) */
.div-grid tbody td.col-freeze  { background: white; }
.div-grid tbody tr.row-deposit td.col-freeze { background: #f0f8ff; }
.div-grid thead th.col-freeze  { background: #f0f2f8; }

/* ── 컬럼 리사이즈 핸들 ── */
th { position: relative; }

.col-resize-handle {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: col-resize;
  z-index: 2;
}

.col-resize-handle:hover {
  background: rgba(74, 144, 226, 0.35);
}

/* ── 이자/예금 종목 행 강조 ── */
.div-grid tbody tr.row-deposit {
  background-color: #f0f8ff;
}

/* ── 월별 입력 셀 ── */
.div-month-cell {
  padding: 2px 4px !important;
}

.div-month-cell.cell-dirty {
  background-color: #fffde7;
}

.month-input {
  width: 100%;
  padding: 3px 5px;
  border: 1px solid transparent;
  border-radius: 3px;
  font-size: 12px;
  font-family: inherit;
  text-align: right;
  background: transparent;
  box-sizing: border-box;
  outline: none;
  color: #333;
}

.month-input:focus {
  border-color: #4a90e2;
  background: white;
}

/* 수정된 셀의 input */
.cell-dirty .month-input {
  background-color: #fffde7;
}

.cell-dirty .month-input:focus {
  background: white;
}

/* ── 이자종목 툴팁 아이콘 ── */
.deposit-tip {
  margin-left: 4px;
  font-size: 11px;
  cursor: help;
  opacity: 0.8;
}

/* ── 읽기전용 셀 ── */
.div-readonly {
  color: #555;
  background-color: #fafafa;
}

/* ── 소계 셀 ── */
.div-subtotal {
  font-weight: 600;
  color: #1a1a2e;
  background-color: #f5f7ff;
}

/* ── 메모 셀 ── */
.div-memo {
  max-width: 150px;
  color: #666;
}

/* col-ellipsis: 텍스트 말줄임 */
.col-ellipsis {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* hover 시 행 배경 */
.div-grid tbody tr:hover td {
  background-color: #f5f7ff;
}
.div-grid tbody tr.row-deposit:hover td {
  background-color: #e6f3ff;
}
.div-grid tbody tr:hover td.col-freeze {
  background-color: #f5f7ff;
}
.div-grid tbody tr.row-deposit:hover td.col-freeze {
  background-color: #e6f3ff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/trade/DividendPage.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B,gDAAgD;AAChD,uBAAuB,OAAO,MAAM,+BAA+B,EAAE;AACrE,oCAAoC,+BAA+B,EAAE;AACrE,oCAAoC,+BAA+B,EAAE;;AAErE,2BAA2B;AAC3B,iCAAiC,iBAAiB,EAAE;AACpD,+CAA+C,mBAAmB,EAAE;AACpE,iCAAiC,mBAAmB,EAAE;;AAEtD,qBAAqB;AACrB,KAAK,kBAAkB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["/* 분배금 등록 화면 */\n\n/* ── 툴바 ── */\n.div-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.div-toolbar-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n  flex-shrink: 0;\n}\n\n.div-acct-select,\n.div-year-select,\n.div-toolbar select {\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n}\n\n.div-year-select {\n  width: 72px;\n}\n\n.div-date-input {\n  padding: 4px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n}\n\n.div-summary-text {\n  font-size: 12px;\n  color: #333;\n  margin-left: 8px;\n  white-space: nowrap;\n}\n\n.div-summary-text strong {\n  color: #1a56db;\n}\n\n/* ── 정렬 가능한 헤더 ── */\n.div-sortable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.div-sortable:hover {\n  background-color: #e8ebf8;\n}\n\n/* ── 고정 컬럼 (left 오프셋) ── */\n/* freeze-c2, freeze-c3 left는 인라인 style로 동적 설정 */\n.div-grid .freeze-c1 { left: 0;     border-right: 1px solid #dde2ef; }\n.div-grid .freeze-c2 {              border-right: 1px solid #dde2ef; }\n.div-grid .freeze-c3 {              border-right: 2px solid #cdd3e8; }\n\n/* 고정 컬럼 배경 (스크롤 시 투명 방지) */\n.div-grid tbody td.col-freeze  { background: white; }\n.div-grid tbody tr.row-deposit td.col-freeze { background: #f0f8ff; }\n.div-grid thead th.col-freeze  { background: #f0f2f8; }\n\n/* ── 컬럼 리사이즈 핸들 ── */\nth { position: relative; }\n\n.col-resize-handle {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  cursor: col-resize;\n  z-index: 2;\n}\n\n.col-resize-handle:hover {\n  background: rgba(74, 144, 226, 0.35);\n}\n\n/* ── 이자/예금 종목 행 강조 ── */\n.div-grid tbody tr.row-deposit {\n  background-color: #f0f8ff;\n}\n\n/* ── 월별 입력 셀 ── */\n.div-month-cell {\n  padding: 2px 4px !important;\n}\n\n.div-month-cell.cell-dirty {\n  background-color: #fffde7;\n}\n\n.month-input {\n  width: 100%;\n  padding: 3px 5px;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  font-size: 12px;\n  font-family: inherit;\n  text-align: right;\n  background: transparent;\n  box-sizing: border-box;\n  outline: none;\n  color: #333;\n}\n\n.month-input:focus {\n  border-color: #4a90e2;\n  background: white;\n}\n\n/* 수정된 셀의 input */\n.cell-dirty .month-input {\n  background-color: #fffde7;\n}\n\n.cell-dirty .month-input:focus {\n  background: white;\n}\n\n/* ── 이자종목 툴팁 아이콘 ── */\n.deposit-tip {\n  margin-left: 4px;\n  font-size: 11px;\n  cursor: help;\n  opacity: 0.8;\n}\n\n/* ── 읽기전용 셀 ── */\n.div-readonly {\n  color: #555;\n  background-color: #fafafa;\n}\n\n/* ── 소계 셀 ── */\n.div-subtotal {\n  font-weight: 600;\n  color: #1a1a2e;\n  background-color: #f5f7ff;\n}\n\n/* ── 메모 셀 ── */\n.div-memo {\n  max-width: 150px;\n  color: #666;\n}\n\n/* col-ellipsis: 텍스트 말줄임 */\n.col-ellipsis {\n  max-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* hover 시 행 배경 */\n.div-grid tbody tr:hover td {\n  background-color: #f5f7ff;\n}\n.div-grid tbody tr.row-deposit:hover td {\n  background-color: #e6f3ff;\n}\n.div-grid tbody tr:hover td.col-freeze {\n  background-color: #f5f7ff;\n}\n.div-grid tbody tr.row-deposit:hover td.col-freeze {\n  background-color: #e6f3ff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
